module.exports = __webpack_public_path__ + "static/image/company/m/image_vision_2@3x.jpg?c5c1d989";